import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { Loader, Text } from "./common";
import StyleConstants from "../shared/constants/styleConstants/styles.json";
import { SnackBar } from "./common";
import Home from "./home";
import FeeBundle from "./feeBundle";
import FeeCollection from "./feeCollection";
import StudentList from "./feeCollection/studentList";
import Report from "./report";
import { Layout } from "./common";
import NotifyServerMaintenance from "./notifyServerMaintenance";
import Landing from "./home/landing";
import ExternalFeeCollection from "./externalFeeCollection";
import PaymentChanges from "./feeCollection/paymentHistoryChanges";
import Tool from "./tools";

class RouteNavigation extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      screenHeight: "",
    };
    this.resize = this.resize.bind(this);
  }

  componentDidMount() {
    this.setState({ screenHeight: global.innerHeight });
    window.addEventListener("resize", this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  resize() {
    this.forceUpdate();
  }

  renderToast() {
    // Do customize toast before use - This is just a sample Toast
    return (
      <div
        style={{
          bottom: 40,
          position: "fixed",
          display: "flex",
          justifyContent: "center",
          width: window.innerWidth * 0.8,
          zIndex: 1001,
          padding: "5px 10px 5px 10px",
        }}
      >
        <Text
          text={this.props.toastMessage}
          style={{ color: StyleConstants.color.white }}
        />
      </div>
    );
  }

  renderServerError() {
    return (
      <div
        style={{ paddingTop: 100, display: "flex", justifyContent: "center" }}
      >
        <Text
          text="Sorry something went wrong, please check your internet connectivity or try again after sometime."
          style={{ fontSize: StyleConstants.textSize.headerSmall }}
        />
      </div>
    );
  }

  renderRouterContent() {
    return (
      <Layout>
        <Router>
          <div
            className="App"
            style={{ minHeight: "100Vh", height: "100% !important" }}
          >
            <SnackBar />
            <Switch>
              <Route exact path="/" component={Landing} />
              <Route exact path="/dashboard" component={Home} />
              <Route exact path="/fee_bundle/:type" component={FeeBundle} />
              <Route exact path="/fee_collection" component={FeeCollection} />
              <Route exact path="/student_list" component={StudentList} />
              <Route exact path="/report" component={Report} />
              <Route
                exact
                path="/external_fee_payment/:institute_id"
                component={ExternalFeeCollection}
              />
              <Route
                exact
                path="/external_fee_payment/:institute_id/:student_id"
                component={ExternalFeeCollection}
              />
              <Route
                exact
                path="/view_changes_to_payments"
                component={PaymentChanges}
              />
              <Route exact path="/tool" component={Tool} />
            </Switch>
          </div>
        </Router>
      </Layout>
    );
  }

  renderBody(isServerUnderMaintenance, isServerError, loaderState) {
    if (isServerUnderMaintenance) {
      return <NotifyServerMaintenance />;
    }
    if (isServerError) {
      return this.renderServerError();
    }
    if (loaderState) {
      return <Loader />;
    }
    // Should Add 404 screen
    return this.renderRouterContent();
  }

  render() {
    const { screenHeight } = this.state;
    const { showToast, isServerError, isServerUnderMaintenance, loaderState } =
      this.props;

    return (
      <Router>
        <div
          className="App"
          style={{
            minHeight: screenHeight,
            backgroundColor: StyleConstants.backgroundColor.default,
          }}
        >
          {showToast && this.renderToast()}
          {this.renderBody(
            isServerUnderMaintenance,
            isServerError,
            loaderState
          )}
        </div>
      </Router>
    );
  }
}

RouteNavigation.propTypes = {
  isServerError: PropTypes.bool,
  isServerUnderMaintenance: PropTypes.bool,
  loaderState: PropTypes.bool,
  showToast: PropTypes.bool,
  toastMessage: PropTypes.string,
  toastMessageType: PropTypes.string,
  userProfile: PropTypes.object,
  notifications: PropTypes.array,
};

RouteNavigation.defaultProps = {
  isServerError: false,
  isServerUnderMaintenance: false,
  loaderState: false,
  showToast: false,
  toastMessage: "",
  toastMessageType: "",
  userProfile: {},
  notifications: [],
};

const mapStateToProps = ({ global }) => ({
  isServerError: global.isServerError,
  isServerUnderMaintenance: global.isServerUnderMaintenance,
  loaderState: global.loaderState,
  toastMessage: global.toastMessage,
  showToast: global.showToast,
  toastMessageType: global.toastMessageType,
});

export default connect(mapStateToProps)(RouteNavigation);
